export default __webpack_public_path__ + "assets/media/203a9852c623c950069a672cd861f3d9.mp3";